import { Card } from "@/components/ui/card";
import { Cake, PartyPopper } from "lucide-react";

const when = (d) => (d === 0 ? "Today" : d === 1 ? "Tomorrow" : `in ${d} days`);

export const Celebrations = ({ items = [] }) => (
  <Card className="p-6 border border-border rounded-xl" data-testid="celebrations-board">
    <div className="flex items-center gap-2 mb-4">
      <PartyPopper className="w-5 h-5 text-accent" />
      <h3 className="font-heading text-lg font-semibold">Celebrations</h3>
      <span className="ml-auto text-[11px] font-mono text-muted-foreground">next 30 days</span>
    </div>
    {items.length === 0 && <p className="text-sm text-muted-foreground py-6 text-center" data-testid="celebrations-empty">No birthdays or anniversaries coming up.</p>}
    <div className="space-y-3">
      {items.map((c) => {
        const bday = c.type === "Birthday";
        return (
          <div key={`${c.employee_id}-${c.type}`} className="flex items-center gap-3" data-testid={`celebration-${c.type === "Birthday" ? "bday" : "anniv"}-${c.employee_id}`}>
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${bday ? "bg-rose-50 text-rose-600 dark:bg-rose-950/50 dark:text-rose-400" : "bg-amber-50 text-amber-600 dark:bg-amber-950/50 dark:text-amber-400"}`}>
              {bday ? <Cake className="w-4 h-4" /> : <PartyPopper className="w-4 h-4" />}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate">{c.name}</p>
              <p className="text-xs text-muted-foreground truncate">
                {bday ? "Birthday" : `${c.years} year${c.years === 1 ? "" : "s"} at Skanovix`} • {new Date(c.date + "T00:00:00").toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
              </p>
            </div>
            <span className={`text-[11px] font-mono px-2 py-0.5 rounded-full ${c.in_days === 0 ? "bg-accent text-accent-foreground" : "bg-secondary text-muted-foreground"}`}>{when(c.in_days)}</span>
          </div>
        );
      })}
    </div>
  </Card>
);
